import { parseResponse } from "../../utils/parseResponse";
import { UserProfileInfo, UserProfileInfoModel } from "../../types";
import { userProfileInfoResponseKeys } from "../responseKeys/responseKeys";

export function parseUserProfileInfo(userProfileInfo: string): UserProfileInfoModel {
    return {
        userProfileInfo: parseResponse<UserProfileInfo>(userProfileInfo, 
            userProfileInfoResponseKeys,
            ['Id', 'CityId'])
    };
}
